// Configurações de ambiente — fonte única para URLs da API
const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  'http://localhost:8000/api';

const backendUrl =
  process.env.REACT_APP_BACKEND_URL ||
  apiBaseUrl.replace(/\/api\/?$/, '') ||
  'http://localhost:8000';

export const config = {
  API_BASE_URL: apiBaseUrl,
  API_URL: apiBaseUrl,
  BACKEND_URL: backendUrl,
  ENV: process.env.REACT_APP_ENV || 'development',
  APP_NAME: process.env.REACT_APP_APP_NAME || 'RochaWMS',
};
